// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4scMubxZpAh8j43kJ5p{width:456px}._4scMubxZpAh8j43kJ5p:hover .MuiSlider-thumb{visibility:visible}._4scMubxZpAh8j43kJ5p .MuiSlider-thumb{visibility:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_4scMubxZpAh8j43kJ5p`
};
export default ___CSS_LOADER_EXPORT___;
